<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" size="lg-fix-h">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" :disabled="isGeneralLoading"/>
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 45vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2">
            <div class="w-full" ref="valueTo">
              <div class="flex items-center mb-1">
                <label class="text-sm font-semibold text-secondary-600 block">{{$t('app.mail_para')}}</label>
                <base-tooltip-icon size="sm" :content="$t('app.mail_info')" class="ml-2" />
              </div>
                <el-form-item prop="valueTo">
                  <!-- <base-el-select class="w-full" v-model="form.valueTo" :options="form.ListaBlancaEmails" :disabled="isLoadingSelect"
                    :placeholder="$t('app.select_entity_multiple_placeholder_long', { entity: $tc('users.email', 2).toLowerCase() })" 
                    maxLength="100" clearable filterable allow-create multiple-create />  -->
                  <el-input class="w-full" v-model="form.valueTo" maxlength="100" />
                </el-form-item>
            </div>
          </div>
          <div class="lg:mb-2">
            <div ref="valueCC">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.mail_cc')}}
                <el-form-item prop="valueCC">
                  <!-- <base-el-select class="w-full" v-model="form.valueCC" :options="form.ListaBlancaEmails" :disabled="isLoadingSelect"
                    :placeholder="$t('app.select_entity_multiple_placeholder_long', { entity: $tc('users.email', 2).toLowerCase() })" 
                    maxLength="100" clearable filterable allow-create multiple-create />  -->
                  <el-input class="w-full" v-model="form.valueCC" maxlength="100" />
                </el-form-item>
              </label>
            </div>
          </div>
          <div class="lg:mb-2">
            <div ref="valueCCO">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.mail_cco')}}
                <el-form-item prop="valueCCO">
                  <!-- <base-el-select class="w-full" v-model="form.valueCCO" :options="form.ListaBlancaEmails" :disabled="isLoadingSelect"
                    :placeholder="$t('app.select_entity_multiple_placeholder_long', { entity: $tc('users.email', 2).toLowerCase() })" 
                    maxLength="100" clearable filterable allow-create multiple-create/>  -->
                  <el-input class="w-full" v-model="form.valueCCO" maxlength="100" />
                </el-form-item>
              </label>
            </div>
          </div>
          <div class="lg:mb-2" v-if="hasModuleCustomMails && false">
            <div ref="AsuntoCorreo">
              <div class="flex items-center mb-1">
                <label class="text-sm font-semibold text-secondary-600 block">{{$t('app.AsuntoCorreo')}}</label>                
              </div>
                <el-form-item prop="AsuntoCorreo">
                  <el-input
                      clearable
                      class="w-full"
                      v-model="form.AsuntoCorreo"
                      maxlength='255'
                    />
                </el-form-item>
            </div>
            <div ref="TextoCorreo">
              <div class="flex items-center mb-1">
                <label class="text-sm font-semibold text-secondary-600 block">{{$t('app.TextoCorreo')}}</label>
                <base-tooltip-icon size="sm" :content="$t('tooltip.texto_correo')" class="ml-2"/>
              </div>
                <el-form-item prop="TextoCorreo">
                  <el-input
                    type="textarea"
                    :rows="2"
                    clearable
                    class="w-full"
                    :aria-label="$t('app.TextoCorreo')"
                    v-model="form.TextoCorreo"
                    maxlength="1000"/>
                </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" :disabled="isGeneralLoading || notSelectedMail" :loading="isGeneralLoading"/>
    </template>
  </base-dialog-button>
</template>

<script>
import { email as emailRegex } from '@/utils/regex'

import { i18n } from '@/i18n'

// import { getWhiteListEmailsMix } from '@/services/clients/lists/getWhiteListEmailsMix'

export default
{
  name: 'input-text-mail-dialog',
  props: {
    header: {
      type: String,
      default: i18n.t('app.important')
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    idCliente: {
      type: [Number, String],
      default: -1
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      isLoadingSelect: false,
      form: {
        valueTo: '',
        valueCC: '',
        valueCCO: '',
        TextoCorreo: '',
        AsuntoCorreo: '',
        GestionarListaBlancaGrupos: false,
        ListaBlancaEmails: [],
      },
      rules: {
        valueTo: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        valueCC: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        valueCCO: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.resetForm()
      // if (value) this.downloadListwhiteEmail()
    }
  },
  mounted: async function () {
  },
  computed: {
    hasModuleCustomMails () {
      return this.$store.getters['auth/hasCustomMailsModule']
    },
    notSelectedMail () {
      return (!this.form.valueTo || this.form.valueTo.length === 0) && 
      (!this.form.valueCC || this.form.valueCC.length === 0) && 
      (!this.form.valueCCO || this.form.valueCCO.length === 0)
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
  },
  methods: {
    resetForm: function () {
      this.form.valueTo = ''
      this.form.valueCC = ''
      this.form.valueCCO = ''
      this.form.TextoCorreo = ''
      this.form.AsuntoCorreo = ''
      this.form.GestionarListaBlancaGrupos = false
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.form)
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
    isEmailValid: function (rule, value, callback) {
      if (!value || value.length === 0) {
        return callback()
      }
      let flag = false
      value.split(';').map(x => x.trim()).filter(x => !!x).forEach(x => {
        if (!emailRegex.test(x)) {
          callback(new Error(i18n.t('validation.email')))
          flag = true
        }
      })
      if (!flag) callback()
    },
    // downloadListwhiteEmail: async function () {
    //   try {
    //     this.isLoadingSelect = true
    //     const result = await getWhiteListEmailsMix({ idCliente: this.idCliente })
    //     if (result.blnError === true) {
    //       this.doFeedback(i18n.t('feedback.error.formated_api_response_error', result))
    //     } else {
    //       this.form.ListaBlancaEmails = result.Emails
    //       this.form.GestionarListaBlancaGrupos = result.GestionarListaBlancaGrupos
    //     }
    //   } catch (error) {
    //     this.doFeedback()
    //   } finally {
    //     this.isLoadingSelect = false
    //   }
    // },
  }
}
</script>
